'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var protocols = require('../protocols-table');

var _protocols = protocols('dnsaddr'),
    dnsaddrCode = _protocols.code;
/**
 * @typedef {import('..').Multiaddr} Multiaddr
 */

/**
 * Resolver for dnsaddr addresses.
 *
 * @param {Multiaddr} addr
 * @returns {Promise<string[]>}
 */


function dnsaddrResolver(_x) {
  return _dnsaddrResolver.apply(this, arguments);
}

function _dnsaddrResolver() {
  _dnsaddrResolver = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(addr) {
    var Resolver, resolver, peerId, _ref, _ref2, hostname, records, addresses;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Resolver = require('./dns');
            resolver = new Resolver();
            peerId = addr.getPeerId();
            _ref = addr.stringTuples().find(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 1),
                  proto = _ref4[0];

              return proto === dnsaddrCode;
            }) || [], _ref2 = _slicedToArray(_ref, 2), hostname = _ref2[1];
            _context.next = 6;
            return resolver.resolveTxt("_dnsaddr.".concat(hostname));

          case 6:
            records = _context.sent;
            addresses = records.flat().map(function (a) {
              return a.split('=')[1];
            });

            if (peerId) {
              addresses = addresses.filter(function (entry) {
                return entry.includes(peerId);
              });
            }

            return _context.abrupt("return", addresses);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _dnsaddrResolver.apply(this, arguments);
}

module.exports = {
  dnsaddrResolver: dnsaddrResolver
};